import { Component } from '@angular/core';

@Component({
  selector: 'app-sort-icon-svg',
  standalone: true,
  template: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.4415 6.62732H22M13.4415 11.4421H19.5547M13.4415 16.2569H17.1094M5.80564 6V18M5.80564 18L2 14.3317M5.80564 18L9.7566 14.3317" stroke="#33006F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  `,
  styles: [`
    :host {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
  `]
})
export class SortIconComponent {}
